import styled from 'styled-components'

const SubsectionTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
`

export default SubsectionTitle
